import { Typography, TypographyProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export const MainContentSectionText = styled((props: TypographyProps) => (
  <Typography {...props} />
))(() => ({
  marginBottom: '0.2rem'
}))
